import { NavigateOptions, useNavigate as useRouterNavigate } from 'react-router-dom';
import { useContext, useCallback, useMemo } from 'react';
import { ClientConfigurationContext, ClientConfigurationEndpoints } from '@ngt/openiddict';

const isRoute = (url: string, apiPaths?: string[]) => {
    if (!url) {
        return true;
    }

    if (!url.match(/^([A-Za-z]*?:)?\/\//)) {
        if (apiPaths?.some(path => url.startsWith(path))) {
            return false;
        }

        return true;
    }


    return false;
}

const useNavigate = () => {
    const navigate = useRouterNavigate();
    const { data: clientConfiguration } = useContext(ClientConfigurationContext);

    const apiPaths = useMemo(() => {
        const paths: string[] = [
            '/api',
            '/ui',
            '/locode',
            '/admin-ui',
            '/connect'
        ];
        
        if (clientConfiguration?.endpoints) {
            for (let key of (Object.keys(clientConfiguration.endpoints) as Array<keyof ClientConfigurationEndpoints>)) {
                const value = clientConfiguration.endpoints[key];

                if (value && typeof value === 'string') {
                    paths.push(value);
                }
            }
        }

        return paths;
    }, [clientConfiguration])

    return useCallback((to: string, options?: NavigateOptions, redirectType?: string) => {
        if (isRoute(to, apiPaths)) {
            navigate(to, options);
            return;
        }

        navigate(`/redirect?type=${redirectType ? encodeURIComponent(redirectType) : ''}`, { replace: true });
        window.location.href = to;
    }, [navigate, apiPaths])
};

export default useNavigate;